<div class="dashboard-wrapper d-flex min-vh-100">
  <main class="container-fluid py-4 px-3 px-lg-5 overflow-auto">
    <!-- Header -->
    <header class="mb-4">
      <p class="fw-bold fst-italic fs-3 m-0 p-0">
        Welcome back {{ entity_name }}
      </p>
      <p class="text-dark text-xs mb-0">
        Here's an overview of your compliance and verification status.
      </p>

      <!-- Alert -->
      <div v-if="showAlert"
        class="d-none alert alert-warning border-0 d-flex justify-content-between align-items-center mt-3 shadow-sm">
        <div class="d-flex align-items-center gap-2 gap-md-3">
          <i class="fas fa-exclamation-triangle fs-4 text-warning"></i>
          <div>
            <strong class="d-block text-xs">
              B-BBEE Verification Due Soon
            </strong>
            <span class="text-xs">
              Your annual B-BBEE verification is due in 45 days. Ensure all documentation is current.
            </span>
          </div>
        </div>
        <button class="btn-close" @click="showAlert = false"></button>
      </div>
    </header>

    <!-- Metrics -->
    <div class="row g-3 mb-4">
      <div v-for="metric in metrics" :key="metric.label" class="col-12 col-sm-6 col-lg-6 col-xl-6">
        <div
          class="glassy-table border rounded-lg shadow-sm h-100 overflow-hidden d-flex align-items-center px-3 py-3 gap-3">

          <!-- Round icon background -->
          <div class="flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle"
            :class="metric.iconBg" style="width: 48px; height: 48px; background-color: rgba(255, 193, 7, 0.15);">
            <i :class="metric.icon" class="fs-5"></i>
          </div>

          <!-- Content -->
          <div class="d-flex flex-column justify-content-center">
            <p class="text-muted text-xs fw-bold mb-1 text-uppercase">
              {{ metric.label }}
            </p>
            <h4 class="fw-bold mb-1">{{ metric.label === 'Employee Documents' ? document_counts.total_documents :
              metric.value }}
            </h4>
            <small class="text-muted text-xxs">{{ metric.subtext }}</small>
          </div>

        </div>
      </div>
    </div>

    <!-- Main Grid -->
    <div class="row g-4">

      <!-- Left Column -->
      <div class="col-lg-8 d-flex flex-column">

        <!-- Recent Documents -->
        <div class="glassy-table border rounded-lg p-4 shadow-sm flex-grow-1">

          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h6 class="fw-bold mb-1">Recent Documents</h6>
              <small class="text-muted">View-only documents</small>
            </div>
            <a v-if="!recent_documents_loading && recentDocuments.length" href="#"
              class="text-primary-blue small fw-bold text-decoration-none" @click.prevent="view_all_documents">
              View All
            </a>
          </div>

          <div class="list-group list-group-flush rounded-lg">

            <!-- Loading state -->
            <div v-if="recent_documents_loading" class="text-muted small py-2 text-center">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Loading...
            </div>

            <!-- Empty state -->
            <div v-else-if="!recentDocuments.length" class="text-muted small py-3 text-center">
              <i class="far fa-folder-open me-2"></i>
              No documents found
            </div>

            <!-- Documents -->
            <div v-else v-for="doc in recentDocuments" :key="doc.name"
              class="list-group-item d-flex flex-row justify-content-between align-items-center gap-2 px-3 py-2">
              <div class="min-width-0 flex-grow-1 overflow-hidden">
                <p class="fw-bold small mb-1 text-truncate">{{ doc.name }}</p>
                <small class="text-muted">{{ doc.date }}</small>
              </div>

              <button class="btn btn-link p-0 text-muted border-0 flex-shrink-0" @click="open_file_preview(doc)">
                <i class="far fa-eye"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Compliance Heatmap -->
        <div class="glassy-table border rounded-lg p-4 shadow-sm d-none">
          <h6 class="fw-bold mb-3">Compliance Heatmap</h6>

          <div class="row g-3 text-center">
            <div v-for="item in heatmapData" :key="item.label" class="col-6 col-md-3 border rounded-lg">
              <div class="rounded-3 p-3 fw-bold" :class="item.colorClass">
                {{ item.value }}%
              </div>
              <small class="text-muted d-block mt-2">
                {{ item.label }}
              </small>
            </div>
          </div>
        </div>

      </div>

      <!-- Right Column -->
      <div class="col-lg-4 d-flex flex-column">

        <!-- Compliance Score -->
        <div class="glassy-table border rounded-lg p-4 shadow-sm mb-4 text-center">
            <h6 class="fw-bold mb-3">Compliance Score</h6>

            <div class="display-5 fw-bold mb-1" :class="compliance_score.colorClass">
                {{ compliance_score.value }}%
            </div>
            <small class="fw-semibold" :class="compliance_score.colorClass">
                {{ compliance_score.label }}
            </small>
        </div>

        <!-- Upcoming Meetings -->
        <div class="glassy-table border rounded-lg p-4 shadow-sm d-flex flex-column d-none">
          <h6 class="fw-bold mb-3">Upcoming Meetings</h6>

          <div v-for="meeting in meetings" :key="meeting.id" class="mb-3">
            <span class="badge small mb-1 bg-success text-white" :class="meeting.badgeClass">
              {{ meeting.type }}
            </span>

            <p class="fw-bold small mb-1">
              {{ meeting.title }}
            </p>

            <small class="text-dark">
              {{ meeting.date }} • {{ meeting.time }}
            </small>
          </div>

          <button class="btn btn-primary-dark text-xs mt-auto w-100" @click="viewCalendar">
            View Calendar
          </button>
        </div>

      </div>
    </div>
  </main>
</div>

<!-- preview file modal -->
<div v-if="show_file_preview" @click.self="close_file_preview">
  <FilePreviewComponent :presigned_url="preview_file_url" :file_name="preview_file_name" @close="close_file_preview"
    :key="preview_file_url" />
</div>